module.exports = __webpack_public_path__ + "img/logo.9cb19d37.png";